var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.58301C15.3729 4.58301 5.08331 14.8726 5.08331 27.4997C5.08331 40.1268 15.3729 50.4163 28 50.4163C40.6271 50.4163 50.9166 40.1268 50.9166 27.4997C50.9166 14.8726 40.6271 4.58301 28 4.58301ZM26.2812 18.333C26.2812 17.3934 27.0604 16.6143 28 16.6143C28.9396 16.6143 29.7187 17.3934 29.7187 18.333V29.7913C29.7187 30.7309 28.9396 31.5101 28 31.5101C27.0604 31.5101 26.2812 30.7309 26.2812 29.7913V18.333ZM30.1083 37.5372C29.9937 37.8351 29.8333 38.0643 29.6271 38.2934C29.3979 38.4997 29.1458 38.6601 28.8708 38.7747C28.5958 38.8893 28.2979 38.958 28 38.958C27.7021 38.958 27.4041 38.8893 27.1291 38.7747C26.8541 38.6601 26.6021 38.4997 26.3729 38.2934C26.1666 38.0643 26.0062 37.8351 25.8916 37.5372C25.7771 37.2622 25.7083 36.9643 25.7083 36.6663C25.7083 36.3684 25.7771 36.0705 25.8916 35.7955C26.0062 35.5205 26.1666 35.2684 26.3729 35.0393C26.6021 34.833 26.8541 34.6726 27.1291 34.558C27.6791 34.3288 28.3208 34.3288 28.8708 34.558C29.1458 34.6726 29.3979 34.833 29.6271 35.0393C29.8333 35.2684 29.9937 35.5205 30.1083 35.7955C30.2229 36.0705 30.2916 36.3684 30.2916 36.6663C30.2916 36.9643 30.2229 37.2622 30.1083 37.5372Z",
    fill: "#FF5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.4e6a37de84c53c983d3d5b1e9eaa25d6.svg";
export { ForwardRef as ReactComponent };